import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ApplicationInsightsService } from './application-insights.service';

@Injectable({
  providedIn: 'root'
})
export class GlobalErrorHandlerService implements ErrorHandler {

  constructor(private readonly injector: Injector) {}

  handleError(error: Error | HttpErrorResponse): void {
    this.injector.get<ApplicationInsightsService>(ApplicationInsightsService).logException(error);
    console.error(error);
    const chunkFailedMessage = /Loading chunk .* failed/;
    const errorMessage = error instanceof Error ? error.message : (error as any)?.rejection?.message;

    if (errorMessage && chunkFailedMessage.test(errorMessage)) {
      const reloadMessage = "It seems there was a problem loading part of the page due to a network or browser issue. Do you want to reload to try again?";
       if(confirm(reloadMessage)) {
           window.location.reload();
         }
    }
  }
}
